/**
 * Compact timestamps for tables: "Oct 28, 3:30 PM" (year only when it isn't
 * the current one). toLocaleString() gave "10/28/2026, 3:30:00 PM", which
 * wrapped onto two lines in every table row.
 */
export function formatDateTime(value: string | number | Date | null | undefined): string {
  if (value === null || value === undefined || value === '') return '—';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '—';
  const sameYear = d.getFullYear() === new Date().getFullYear();
  return d.toLocaleString(undefined, {
    month: 'short', day: 'numeric', ...(sameYear ? {} : { year: 'numeric' }),
    hour: 'numeric', minute: '2-digit',
  });
}
